import OcrInterceptor from '../OcrInterceptor'
import { TipoTemplate } from '../../../types/Enums/Ocr'

const api = new OcrInterceptor()

export default {
  getCamposSaida(templateType: TipoTemplate) {
    return api.get(`/campos-saida/${templateType}`)
  },
}
